export default "__VITE_ASSET__CHsJlPAA__"